import React from 'react';
import { SM, LG } from '@zendeskgarden/react-typography';
import { Row, Col } from '@zendeskgarden/react-grid';
import { BlogPostItem } from 'routes/BlogList/components/BlogPosts/BlogPosts';
import { map, take } from 'lodash';
import { PropTypes } from 'prop-types';

function RelatedBlogPosts({ clamp, setClamp, contentList }) {
  const allContent = contentList?.result?.docs || [];
  const contentClamp = clamp ? take(allContent, 4) : allContent;
  return (
    <div>
      <Row style={{ paddingBottom: '40px' }}>
        <Col>
          <LG scaled navy bold>
            Related Content
          </LG>
        </Col>
        {allContent && allContent.length > 4 ? (
          <Col size="auto" alignCenter justifyEnd>
            <SM
              onClick={() => setClamp(!clamp)}
              style={{ marginBottom: '0' }}
              link
            >
              {clamp ? 'See All Resources' : 'Hide Resources'}
            </SM>
          </Col>
        ) : null}
      </Row>
      <Row>
        {map(contentClamp, (c, i) => (
          <Col
            style={{ marginBottom: '30px' }}
            key={i}
            size="12"
            sm="6"
            md="4"
            lg="3"
          >
            <BlogPostItem small clamp={clamp ? 3 : false} content={c} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

RelatedBlogPosts.propTypes = {
  clamp: PropTypes.bool,
  setClamp: PropTypes.func,
  contentList: PropTypes.shape({
    result: PropTypes.shape({
      // LINT OVERRIDE #8
      // TECH DEBT
      // Array has undetermined elements
      // eslint-disable-next-line react/forbid-prop-types
      docs: PropTypes.array,
    }),
  }),
};

export default RelatedBlogPosts;
